import { WatcherType } from "../types/watcherType";
import { validateCity } from "../utils/validateCity";
import { validateHaveDisability } from "../utils/validateHaveDisability";

export const watcherHaveDisability = (props : WatcherType) => {
    const { watcher, currentStep, fields, getValues, setValue } = props;
    const cityValue = getValues("city")
    const isValidCity = validateCity(cityValue)
    const validateDisabilityValue = validateHaveDisability(watcher);
        let process =  [...fields];
        process = process.map((section, idx) => {
            if (!section.fields || idx !== currentStep) return section
            let fields = [
                ...section?.fields.map((field: any) => {
                    if (
                        field.name === "discapacityCondition"
                    ) {
                        return { ...field, hidden: true };
                    }  
                    return field;
                }),
            ];
            if (watcher === "SÍ") {
                fields = fields.map((field: any) => {
                    if (field.name === "discapacityCondition") {
                        return { ...field, hidden: false };
                    }
                    if (
                        field.name === "interest"
                       
                    ) {
                        const hidden = isValidCity && validateDisabilityValue
                        if(!hidden){
                            setValue("interest", "")
                        }
                        return { ...field, hidden: !hidden };
                    }
                    return field;
                });
            }
            if (watcher === "NO") {
                fields = fields.map((field: any) => {
                    if (
                        field.name === "interest"
                       
                    ) {
                        const hidden = isValidCity && validateDisabilityValue
                        if(!hidden){
                            setValue("interest", "")
                        }
                        return { ...field, hidden: !hidden };
                    }
                    return field;
                });
            }
            return { ...section, fields };
        }); 
        
        return process;
}
